export const BASE_URL = '/api'
export const USER_INFO = BASE_URL + '/userInfo'
export const AUTHENTICATE = BASE_URL + '/login'
